import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-search-bar',
  templateUrl: './search-bar.component.html',
  styleUrls: ['./search-bar.component.scss'],
})
export class SearchBarComponent implements OnInit {
  @Input() placeholder = 'Rechercher un patient...';
  @Output() searchEvent = new EventEmitter<string>();
  // CORE ATTRIBUTES
  public inputSearchText: string;
  public currentSearch: string;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {
    // do nothing
  }

  ngOnInit(): void {
    firstValueFrom(this.activatedRoute.queryParams).then((params) => {
      this.currentSearch = params['query'];
    });
  }

  onChange(): void {
    this.currentSearch = this.inputSearchText;
    this.inputSearchText = '';

    this.searchEvent.emit(this.currentSearch);
    this.updateQueryParams();
  }

  clearCurrentQuery(): void {
    this.currentSearch = '';
    this.updateQueryParams();
    this.searchEvent.emit(this.inputSearchText);
  }

  updateQueryParams(): void {
    // update in url query
    if (this.currentSearch?.length > 0) {
      this.router
        .navigate([], {
          queryParams: {
            query: this.currentSearch,
          },
        })
        .then();
    } else {
      this.router.navigate([]).then();
    }
  }

  get isOnSearchMode(): boolean {
    return this.currentSearch != null && this.currentSearch.length > 0;
  }
}
